import React, { useState, useMemo, useRef } from "react";
import { Row, Col, Table, Button } from "react-bootstrap";
import { colors } from "../configs";
import { useSelector } from "react-redux";
import { endCutoff, formatCurrency, handleDigit, startCutoff, summary } from "../Utility/function";
import { NumberYMD, getHoursMinute, plusDays, stringFullDate, stringYMDHMS, stringYMDHMS3 } from "../Utility/dateTime";
import Dropdown from 'react-bootstrap/Dropdown';
import html2canvas from 'html2canvas';
import { reverseSort } from "../Utility/sort";
import { useTranslation } from 'react-i18next';
import * as XLSX from 'xlsx';
import { ChartScreen, Download, TimeControl } from "../components";

const { darkGray, white, backgroundColor } = colors;
const options = [
  {id:1,name:'รายงานแบบย่อ'},
  {id:2,name:'รายงานแบบเต็ม'},
];

function ReportDailyScreen() {
  const { t } = useTranslation();
  const { shop } = useSelector((state)=> state.shop)
  const { cutOff } = shop;
  const { selectedBill, startDate, endDate } = useSelector((state)=> state.bill)
  const [option, setOption] = useState({id:1,name:'รายงานแบบย่อ'})

    function manageData(bills){

        let datasets = [] // ยอดขายรายวัน
            let starter = startDate
            
            do {
              const start = stringYMDHMS(startCutoff(starter,new Date(cutOff)));
              const end = stringYMDHMS(endCutoff(starter,new Date(cutOff)));
              let totalSale = 0;
              let totalCost = 0;
              let billQty = 0;
              const data = bills.filter((item)=>{return(stringYMDHMS(item.dateTime) > start && stringYMDHMS(item.dateTime) <= end)})
              data.forEach(item=>{
                const { moneyMustPaid, product } = item;
                totalSale += moneyMustPaid
                product.forEach(a=>{
                  const { totalCost:cost } = a;
                  totalCost += Number(cost)
                })
                billQty ++
              })
              const profit = totalSale - totalCost
              const profitPercent = totalSale>0?profit*100/totalSale:0;
              const averageSale = billQty>0?totalSale/billQty:0;
              datasets.push({
                name:stringFullDate(starter),
                ยอดขายรายวัน:parseFloat(totalSale.toFixed(2)),
                billQty,
                totalSale,
                totalCost,
                profit,
                profitPercent,
                averageSale
              })
              starter = plusDays(starter,1)
            }

            while (NumberYMD(starter) <= NumberYMD(endDate));


        return { datasets, bar:'ยอดขายรายวัน'}
    };

    const { display, datasets, bar, sumBillQty, sumTotalSale, sumTotalCost,
      sumProfit, profitPercent, averaeSale
     } = useMemo(()=>{
        let sumBillQty = 0
        let sumTotalSale = 0
        let sumTotalCost = 0
        let display = []
        const { datasets, bar } = manageData(selectedBill)
        if(option.id===1){
            display = datasets
        } else {
            display = reverseSort('dateTime',selectedBill.map(a=>{
              const { moneyMustPaid, product } = a;
              let totalCost = 0
              product.forEach(b=>{
                const { totalCost:cost } = b;
                totalCost += Number(cost)
              })
              const profit = moneyMustPaid - totalCost
              const profitPercent = profit*100/moneyMustPaid;
              const averageSale = moneyMustPaid;
              return {
                ...a,
                billQty:1,
                totalSale:moneyMustPaid,
                totalCost,
                profit,
                profitPercent,
                averageSale
              }
            }))
        }
        
        display.forEach(item=>{
          const { billQty, totalSale, totalCost } = item;
          sumBillQty += billQty
          sumTotalSale += totalSale
          sumTotalCost += totalCost
        })
        const sumProfit = sumTotalSale - sumTotalCost
        const profitPercent = sumTotalSale>0?parseFloat((sumProfit*100/sumTotalSale).toFixed(2)):0;
        const averaeSale = sumBillQty>0?parseFloat((sumTotalSale/sumBillQty).toFixed(2)):0
        return { 
          display:display.map(a=>{
            return {
              ...a,
              totalSale:handleDigit(a.totalSale),
              totalCost:handleDigit(a.totalCost),
              profit:handleDigit(a.profit),
              profitPercent:handleDigit(a.profitPercent),
              averageSale:handleDigit(a.averageSale)
            }
          }), 
          datasets, 
          bar,
          sumBillQty,
          sumTotalSale:handleDigit(sumTotalSale),
          sumTotalCost:handleDigit(sumTotalCost),
          sumProfit:handleDigit(sumProfit),
          profitPercent:handleDigit(profitPercent),
          averaeSale:handleDigit(averaeSale)
        }
    },[selectedBill,option])

  const displayRef = useRef(null);

  const handleCapture = () => {
    if (displayRef.current) {
      html2canvas(displayRef.current)
        .then((canvas) => {
          const imgData = canvas.toDataURL('image/png');
          const link = document.createElement('a');
          link.href = imgData;
          link.download = `ยอดขายรายวัน ${stringFullDate(startDate,t)} - ${stringFullDate(endDate,t)}.png`;
          link.click();
        });
    }
  };

  const exportToXlsxFull = () => {
    // Define the headers
    const headers = [
      ["วันที่", "เวลา", "เลขที่บิล", "ยอดขาย", "ต้นทุน", "กำไร", "อัตรากำไร", "จำนวนใบเสร็จ", "ยอดขายต่อใบเสร็จ"]
    ];
  
    // Map the data from the table
    const data = display.map((item, index) => [
      stringFullDate(item.dateTime),
      getHoursMinute(item.dateTime),
      item.receiptNumber,
      item.totalSale,
      item.totalCost,
      item.profit,
      item.profitPercent,
      item.billQty,
      item.averageSale,
    ]);
  
    // Add the total row with "รวม" spanning two columns
    data.push([
      "รวม", "","",  // These will be merged
      sumTotalSale,
      sumTotalCost,
      sumProfit,
      profitPercent,
      sumBillQty,
      averaeSale,
    ]);
  
    // Create the worksheet and workbook
    const worksheet = XLSX.utils.aoa_to_sheet([...headers, ...data]);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "ยอดขายรายวันแบบเต็ม");
  
    // Merge "รวม" over two columns (A12:B12 if it's row 12)
    worksheet["!merges"] = [
      { s: { r: data.length, c: 0 }, e: { r: data.length, c: 2 } } // Merge first two cells of last row
    ];
  
    // Trigger file download
    XLSX.writeFile(workbook, `ยอดขายรายวันแบบเต็ม ${stringYMDHMS3(startDate)} - ${stringYMDHMS3(endDate)}.xlsx`);
  };


  const exportToXlsxShort = () => {
    // Define the headers
    const headers = [
      ["วันที่", "ยอดขาย", "ต้นทุน", "กำไร", "อัตรากำไร", "จำนวนใบเสร็จ", "ยอดขายต่อใบเสร็จ"]
    ];
  
    // Map the data from the table
    const data = display.map((item, index) => [
      item.name,
      item.totalSale,
      item.totalCost,
      item.profit,
      item.profitPercent,
      item.billQty,
      item.averageSale,
    ]);
  
    // Add the total row with "รวม" spanning two columns
    data.push([
      "รวม", 
      sumTotalSale,
      sumTotalCost,
      sumProfit,
      profitPercent,
      sumBillQty,
      averaeSale,
    ]);
  
    // Create the worksheet and workbook
    const worksheet = XLSX.utils.aoa_to_sheet([...headers, ...data]);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "ยอดขายรายวันแบบย่อ");
  
    // // Merge "รวม" over two columns (A12:B12 if it's row 12)
    // worksheet["!merges"] = [
    //   { s: { r: data.length, c: 0 }, e: { r: data.length, c: 2 } } // Merge first two cells of last row
    // ];
  
    // Trigger file download
    XLSX.writeFile(workbook, `ยอดขายรายวันแบบย่อ ${stringYMDHMS3(startDate)} - ${stringYMDHMS3(endDate)}.xlsx`);
  };

  const exportToXlsx = () => {
    if(option.id === 1){
      exportToXlsxShort()
    } else {
      exportToXlsxFull()

    }
  };


  return (
    <div style={{ minHeight:'100vh', }} >
      <div style={{position:"sticky", top:0, backgroundColor, zIndex:9}} >
        <h1>ยอดขายรายวัน</h1>
        <TimeControl/>
      </div>
     
      <Row ref={displayRef}  style={styles.container} >
          <Col  lg={12} >
            <div style={styles.container2} >
                <div style={styles.container3} >
                  <h4>ยอดขายสุทธิ: <b>{formatCurrency(summary(selectedBill,'moneyMustPaid'))}</b> {t('currency')} </h4>
                  <Button onClick={handleCapture} variant="danger" >
                  {t('reportDay.saveGraph')}
                  </Button>
                </div>
                <ChartScreen chart={datasets} bar={bar} name={t('reportDay.date')} content={t('reportDay.sale')}  />
            </div>
          </Col>
      </Row>
      <div style={styles.container4} >
            <Dropdown data-bs-theme={darkGray}  >
                <Dropdown.Toggle id="dropdown-button-dark-example1" variant="secondary" style={styles.container5} >
                    {option.name}
                </Dropdown.Toggle>
                <Dropdown.Menu style={styles.container6} >
                    {options.map((item,index)=>{
                        return(
                            <Dropdown.Item key={index} onClick={()=>{setOption(item)}} >{item.name}</Dropdown.Item>
                        )
                    })}
                </Dropdown.Menu>
            </Dropdown>
            <Download exportToXlsx={exportToXlsx} />
      </div>
        
            
        {option.id===1
              ?<Row>
                <Table striped bordered hover responsive  variant="light" style={styles.container7}  >
                    <thead  >
                    <tr>
                      <th style={styles.container9}>วันที่</th>
                      <th style={styles.container10}>ยอดขาย</th>
                      <th style={styles.container10}>ต้นทุน</th>
                      <th style={styles.container10}>กำไร</th>
                      <th style={styles.container10}>อัตรากำไร</th>
                      <th style={styles.container10}>จำนวนใบเสร็จ</th>
                      <th style={styles.container10}>ยอดขายต่อใบเสร็จ</th>
                    </tr>
                  </thead>
                  <tbody  >
                    {display.map((item, index) => {
                      const { name, billQty, totalSale, totalCost, profit, profitPercent, averageSale } = item;
                      return <tr  key={index} >
                              <td style={styles.container11}>{name}</td>
                              <td style={styles.container11}>{totalSale}</td>
                              <td style={styles.container11}>{totalCost}</td>
                              <td style={styles.container11}>{profit}</td>
                              <td style={styles.container11}>{profitPercent}</td>
                              <td style={styles.container11}>{billQty}</td>
                              <td style={styles.container11}>{averageSale}</td>
                            </tr>
                    })}
                    <tr   >
                      <td style={styles.container11}>รวม</td>
                      <td style={styles.container11}>{sumTotalSale}</td>
                      <td style={styles.container11}>{sumTotalCost}</td>
                      <td style={styles.container11}>{sumProfit}</td>
                      <td style={styles.container11}>{profitPercent}</td>
                      <td style={styles.container11}>{sumBillQty}</td>
                      <td style={styles.container11}>{averaeSale}</td>
                    </tr>
                  </tbody>
                </Table>
              </Row>
              :<Row>
                <Table striped bordered hover responsive  variant="light" style={styles.container7}  >
                  
                  <thead  >
                    <tr>
                      <th style={styles.container9} >วันที่</th>
                      <th style={styles.container9} >เวลา</th>
                      <th style={styles.container9} >เลขที่บิล</th>
                      <th style={styles.container10}>ยอดขาย</th>
                      <th style={styles.container10}>ต้นทุน</th>
                      <th style={styles.container10}>กำไร</th>
                      <th style={styles.container10}>อัตรากำไร</th>
                      <th style={styles.container10}>จำนวนใบเสร็จ</th>
                      <th style={styles.container10}>ยอดขายต่อใบเสร็จ</th>
                    </tr>
                  </thead>
                  <tbody  >
                    {display.map((item, index) => {
                      const { dateTime, receiptNumber, billQty, totalSale, totalCost, profit, profitPercent, averageSale } = item;
                      return <tr   key={index} >
                              <td style={styles.container11} >{stringFullDate(dateTime)}</td>
                              <td style={styles.container11}>{getHoursMinute(dateTime)}</td>
                              <td style={styles.container11}>{receiptNumber}</td>
                              <td style={styles.container11}>{totalSale}</td>
                              <td style={styles.container11}>{totalCost}</td>
                              <td style={styles.container11}>{profit}</td>
                              <td style={styles.container11}>{profitPercent}</td>
                              <td style={styles.container11}>{billQty}</td>
                              <td style={styles.container11}>{averageSale}</td>
                            </tr>
                    })}
                    <tr   >
                      <td colSpan={3} style={styles.container11}>รวม</td>
                      <td style={styles.container11}>{sumTotalSale}</td>
                      <td style={styles.container11}>{sumTotalCost}</td>
                      <td style={styles.container11}>{sumProfit}</td>
                      <td style={styles.container11}>{profitPercent}</td>
                      <td style={styles.container11}>{sumBillQty}</td>
                      <td style={styles.container11}>{averaeSale}</td>
                    </tr>
                  </tbody>
                </Table>
              </Row>
          }
    </div>
  );
};

const styles = {
    container : {
      backgroundColor:white,borderRadius:20,marginLeft:0,marginRight:0,marginBottom:20
    },
    container2 : {
      backgroundColor:white,margin:5,padding:10,borderRadius:20,height:'400px',marginRight:0,overflowX:'auto'
    },
    container3 : {
      display:'flex',justifyContent:'space-between',alignItems:'center'
    },
    container4 : {
      display:'flex',alignItems:'center',justifyContent:'flex-end',padding:10
    },
    container5 : {
      minWidth:'150px'
    },
    container6 : {
      maxHeight: '200px', overflowY: 'auto'
    },
    container7 : {
      marginLeft:'1rem'
    },
    container8 : {
      width:'10%', textAlign:'center'
    },
    container9 : {
      width:'30%', textAlign:'center', minWidth:'250px'
    },
    container10 : {
      width:'10%', textAlign:'center', minWidth:'180px'
    },
    container11 : {
      textAlign:'center'
    }
}

export default ReportDailyScreen;
